import { useState, useCallback } from 'react';

export function useFilters() {
    const [filters, setFilters] = useState({});

    const updateFilter = useCallback((fieldId, value) => {
        console.log('useFilters: Updating filter', fieldId, '=', value);
        setFilters(prev => {
            // If value is empty/null/undefined, remove the filter
            if (!value || (Array.isArray(value) && value.length === 0) || 
                (typeof value === 'string' && value.trim() === '')) {
                const newFilters = { ...prev };
                delete newFilters[fieldId];
                console.log('useFilters: Removed filter, new filters:', newFilters);
                return newFilters;
            }
            
            // Store only field ID and value, not field configuration
            const newFilters = {
                ...prev,
                [fieldId]: value
            };
            console.log('useFilters: Updated filters:', newFilters);
            return newFilters;
        });
    }, []);

    const clearFilters = useCallback(() => {
        setFilters({});
    }, []);

    const removeFilter = useCallback((fieldId) => {
        setFilters(prev => {
            const newFilters = { ...prev };
            delete newFilters[fieldId];
            return newFilters;
        });
    }, []);

    return {
        filters,
        updateFilter,
        clearFilters,
        removeFilter
    };
}
